<div
    *transloco="let t"
    [class]="'bazis-control bazis-control_ghost ' + cssClassSizeControl"
    [ngClass]="{
        'bazis-control--focused': isFocused,
        'bazis-control--dirty': field.dirty,
        'bazis-control--empty': emptyValues.indexOf(ngControl.control.value) > -1,
        'bazis-control--invalid': ngControl.control.invalid,
        'bazis-control--disabled': field.disabled,
    }"
    (clickOutside)="save()"
>
    @let required = required$ | async;
    @let valueChanges = valueChanges$ | async;
    @let statusChanges = statusChanges$ | async;
    <!-- @let fieldValueChanges = fieldValueChanges$ | async; -->
    <div
        class="bazis-control__field-group"
        [class.bazis-control__field-group--disabled]="field.disabled"
        [class.bazis-control__field-group--focused]="isFocused"
    >
        @if (isLeftIconClickable) {
            <div class="bazis-control__field-group__start">
                <!-- @if (isViewTypeReadonly) { -->
                <bazis-button fill="clear">
                    <bazis-icon
                        slot="icon-only"
                        icon="edit-alt"
                    ></bazis-icon>
                </bazis-button>

                <!--} @else {
                <bazis-button
                    fill="clear"
                    [disabled]="!field.value && !formatter"
                    (click)="save()"
                >
                    <bazis-icon
                        slot="icon-only"
                        [icon]="field.value || formatter ? 'check' : 'edit-alt'"
                    ></bazis-icon>
                </bazis-button>
                } -->
            </div>
        }
        <!-- @if (!isViewTypeReadonly) { -->
        <input
            #ghostInput
            type="text"
            class="bazis-control__field bazis-control__field--erasable"
            [size]="
                ghostInput.value
                    ? ghostInput.value.length + 1
                    : ngControl.control.value
                      ? ngControl.control.value.length + 1
                      : ghostInput.placeholder
                        ? ghostInput.placeholder.length + 1
                        : 1
            "
            [formControl]="field"
            [placeholder]="placeholder ? placeholder : placeholderKey ? t(placeholderKey) : ''"
            (focus)="focusField($event)"
            (blur)="blurField($event)"
        />
        <!-- } @else {
            <div class="bazis-control__field bazis-control__field--readonly">
                <span class="bh-ellipsis">{{ ngControl.control.value }}</span>
            </div>
        } -->

        <div class="bazis-control__field-group__end">
            @if (isRightIconClickable) {
                @if (isViewTypeReadonly) {
                    <bazis-button fill="clear">
                        <bazis-icon
                            slot="icon-only"
                            icon="edit-alt-solid"
                        ></bazis-icon>
                    </bazis-button>
                }
                <!-- @else {
                        <bazis-button
                            fill="clear"
                            [disabled]="!field.value && !formatter && !canSaveEmpty"
                            (click)="save()"
                        >
                            <bazis-icon
                                slot="icon-only"
                                [icon]="
                                    field.value || (canSaveEmpty && !savedEmpty) || formatter
                                        ? 'check'
                                        : 'edit-alt-solid'
                                "
                            ></bazis-icon>
                        </bazis-button>
                    } -->
            }
            <!-- @if (field.value && !isViewTypeReadonly) {
                <bazis-button
                    fill="clear"
                    class="bazis-eraser"
                    tabindex="-1"
                    (click)="onClear($event)"
                >
                    <bazis-icon
                        slot="icon-only"
                        [name]="icons.eraser"
                    ></bazis-icon>
                </bazis-button>
            } -->
        </div>
    </div>
</div>
